import {CACHE_KEY_DPJ_OFFICE} from '@/modules/configuration/contants/dpjOffice';
import {fields} from '@/modules/configuration/contants/dpjOffice.form';
import DpjOfficeApiService from '@/modules/configuration/services/DpjOfficeApiService';
import {createFieldsHook} from '@/utils/createFieldsHook';
import {createGetOneHook} from '@/utils/createGetOneHook';

export const useGetOneDpjOffice = createGetOneHook(DpjOfficeApiService, 'id', CACHE_KEY_DPJ_OFFICE);
export const useFields = createFieldsHook('dpjOffice', fields);
